const rawUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "https://kinetirx.nodedr.com";

export const site = {
  name: "KinetiRx",
  shortName: "KinetiRx",
  productName: "Pharma Care Pro",
  legalName: "NODEDR INFOTECH PRIVATE LIMITED",
  ownerName: "Raktim Ranjit",
  tagline: "Self-hosted pharmacy management — billing, inventory, and patient records on your own server",
  description:
    "KinetiRx (Pharma Care Pro) is a self-hosted pharmacy and small-clinic management system. POS billing with GST invoicing, medicine inventory with batch/expiry tracking, due-khata credit ledger, patient records and OPD visits, AI-powered purchase-invoice OCR, expense tracking, and role-based staff accounts — running on Go, PostgreSQL, and Docker Compose, on a server you control.",
  url: rawUrl.replace(/\/$/, ""),
  email: "info@nodedr.com",
  nodedrUrl: "https://www.nodedr.com",
  repoUrl: "https://github.com/Raktim94/KinetiRx",
  repoIssuesUrl: "https://github.com/Raktim94/KinetiRx/issues",
  repoWikiUrl: "https://github.com/Raktim94/KinetiRx/wiki",
  quickStartUrl: "https://github.com/Raktim94/KinetiRx#quick-start-docker-compose",
  formName: "KinetiRx contact",
  submitPath: "/api/submit",
  thankYouPath: "/thank-you",
  ogImage: "/opengraph-image.png",
  port: 9315,
  debVersion: "1.6.14",
  installLinuxUrl: "https://kinetirx.nodedr.com/install-linux.sh",
  debAmd64Url: "/downloads/kinetirx-amd64.deb",
  debArm64Url: "/downloads/kinetirx-arm64.deb",
} as const;

export function absoluteUrl(path: string): string {
  return new URL(path, site.url).toString();
}
